import { Component, OnInit } from '@angular/core';
import { PaypalPromoCodeModal } from '../../models/PaypalPromocode.model';
import { SaPaypalPromocodeServiceService } from '../../services/SaPaypalPromocodeService.service';
import { PaypalProductModal } from '../../../Paypal/models/PaypalProduct.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel} from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-paypal-promocode',
  templateUrl: './paypal-promocode.component.html',
  styleUrls: ['./paypal-promocode.component.css']
})
export class PaypalPromocodeComponent implements OnInit {
  editModal: boolean = false;
  today;
  createModal: boolean = false;
  demoTrialSelected: boolean = true;
  registeredSelected: boolean = false;
  productType: string;
  insertPromoCode: PaypalPromoCodeModal;
  updatePromoCode: PaypalPromoCodeModal;
  typeName: string = '1';
  demoValueSelected: number = 1;
  discAmountControlLabel: number = null;
  minAmountSelected: boolean = false;
  disPercentage: boolean = false;
  minAmountSelectedSecond: boolean = false;
  typeNameVal: number = 2;
  usageLabelUp: number = 0;
  usageLabel: number = 1;
  demoTrialSelectedUp: boolean = true;
  registeredSelectedUp: boolean = false;
  productTypeUp: string = '1';
  demoValueSelectedUp: number = 1;
  minAmountSelectedUp: boolean = false;
  disPercentageUp: boolean = false;
  minAmountSelectedSecondUp: boolean = false;
  typeNameValUp: number = 2;
  isUsedUpdate: boolean;
  isChecked: boolean;
  updateId: string = '';
  promoidLabelUp: string = '';
  allProducts: PaypalProductModal[] = [];
  expiryLabelUp: string;
  showSmallLoad: boolean = false;
  licensesNoLabelUp: number = 1;
  licensesNoLabel: number = 1;
  licensesNoLabelValidityUp: number = 1;
  productListData: PaypalProductModal[] = [];
  showOverlayPaypalPromoCode: boolean = false;
  searchTermLogPromo: string = '';
  moreModal: boolean = false;
  promoCodeData: PaypalPromoCodeModal;
  minAmountControlLabelSec: number = 0;
  licensesNoLabelValidity: number = 1;
  pName: string = '';
  pNameUp: string = '';
  pAmount: number = 0;
  pAmountUp: number = 0;
  minAmountControlLabelUp: number = null;
  minAmountControlLabel: number = null;
  updatePromoCodeData: PaypalPromoCodeModal;
  discAmountControlLabelPerup: number = null;
  discAmountControlLabelPer: number = null;
  discAmountControlLabelUp: number = null;
  minAmountControlLabelSecUp: number = null;
  singleLicenseCost: number = 0;
  promoCodeList: PaypalPromoCodeModal[] = [];
  promoPageNo: number = 1;
  showOverlaySmallLoad: boolean = false;
  promoActionHistory: PaypalPromoCodeModal[] = [];
  promoTotalCount: number = 0;
  changedSearchField: boolean = false;
  mainViewError = new ErrorModel();
  searchError = new ErrorModel();
  historyError = new ErrorModel();

  constructor(private service: SaPaypalPromocodeServiceService) {}

  ngOnInit() {
    this.changedSearchField = false;
    this.promoTotalCount = 0;
    this.today = new Date().toISOString().split('T')[0];
    this.promoPageNo = 1;
    this.showOverlayPaypalPromoCode = true;
    this.insertPromoCode = new PaypalPromoCodeModal();
    this.getProductList();
    this.getAllPromoCodes();
  }

  onMoreInfo(id) {
    this.promoCodeData = new PaypalPromoCodeModal();
    const index = this.promoCodeList.findIndex(promo => promo.id == id);
    this.promoCodeData = this.promoCodeList[index];
    this.moreModal = true;
  }

  getAllPromoCodes() {
    this.mainViewError.display = false;
    this.service.getAllPromoCodes(1, this.searchTermLogPromo).subscribe(
    (data) => {
      this.promoCodeList = data['promos'] as PaypalPromoCodeModal[];
      this.promoTotalCount = data['promoCount'];
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayPaypalPromoCode = false;
    });
  }



  onScrollGetPromoCodes() {
    this.promoPageNo++;
    this.showOverlaySmallLoad = true;
    this.service.getAllPromoCodes(this.promoPageNo, this.searchTermLogPromo).subscribe(
    (data) => {
      const returnData: PaypalPromoCodeModal[] = data['promos'];
      returnData.forEach(i => {
        this.promoCodeList.push(i);
      });
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load now!', AlertType.Error);

    }).add(() => {
      this.showOverlaySmallLoad = false;
      this.showOverlayPaypalPromoCode = false;
    });
  }


  searchPromo() {
    this.changedSearchField = true;
    this.showOverlaySmallLoad = true;
    this.searchError.display = false;
    this.service.getAllPromoCodes(1, this.searchTermLogPromo).subscribe(
    (data) => {
      this.promoCodeList = [];
      this.promoCodeList = data['promos'] as PaypalPromoCodeModal[];
    },
    (error) => {
      this.searchError.error = error;
      this.searchError.display = true;
    }).add(() => {
      this.showOverlayPaypalPromoCode = false;
      this.showOverlaySmallLoad = false;
    });
  }

  getProductList() {
    // SaProductListModal
    this.service.getProductsList().subscribe(
    (data: PaypalProductModal[]) => {

      this.allProducts = data;
      this.productListData = this.allProducts.filter(product => product.productType == 1);
      this.productListData.forEach(i => {
        i.amount += this.allProducts.filter(product => product.productType == 4)[0].amount;
      });
      this.singleLicenseCost = this.allProducts.filter(product => product.productType == 4)[0].amount;
      this.productType = this.productListData[0].id;
    });
  }


  handleChange(input) {
    const inputt = parseInt(input);
    if (inputt !== undefined && inputt !== null) {
      if (inputt < 1 || inputt > 99) {
        this.discAmountControlLabelPer = 1;
        AlertMessages.Show('Warning', 'Discount %age cannot be less than 1 and greater than 99', AlertType.Warning)
      }
    }
    return;
  }

  handleChangeUp(input) {
    const inputt = parseInt(input);
    if (inputt !== undefined && inputt !== null) {
      if (inputt < 1 || inputt > 99) {
        this.discAmountControlLabelPerup = 1;
        AlertMessages.Show('Warning', 'Discount %age cannot be less than 1 and greater than 99', AlertType.Warning)
      }
    }
    return;
  }

  editModalClick(id, isUsed) {
    this.updateId = '';
    this.updatePromoCodeData = new PaypalPromoCodeModal;
    this.isUsedUpdate = false;
    this.createModal = false;
    this.editModal = true;
    this.updateId = id;
    this.isUsedUpdate = isUsed;
    const indexUpdate = this.promoCodeList.findIndex(promo => promo.id == id);
    this.updatePromoCodeData = this.promoCodeList[indexUpdate];
    this.productTypeUp = this.updatePromoCodeData.productId;
    this.typeNameValUp = this.updatePromoCodeData.promoCodeType;
    this.minAmountControlLabelUp = this.updatePromoCodeData.minimumAmount;
    this.discAmountControlLabelPerup = this.updatePromoCodeData.discountPercentage;
    this.discAmountControlLabelUp = this.updatePromoCodeData.discountAmountUpto;
    this.minAmountControlLabelSecUp = this.updatePromoCodeData.discountFixedAmount;
    this.promoidLabelUp = this.updatePromoCodeData.promoName;
    this.expiryLabelUp = this.updatePromoCodeData.promoExpiryDate;
    this.licensesNoLabelUp = this.updatePromoCodeData.licensesCount;
    this.licensesNoLabelValidityUp = this.updatePromoCodeData.licenseDays;
    this.usageLabelUp = this.updatePromoCodeData.promoUsage;
    if (this.typeNameValUp == 1) {
      this.demoTrialSelectedUp = true;
      this.registeredSelectedUp = false;
      this.typeNameValUp = 1;
      if (this.updatePromoCodeData.discountType == 1) {

        this.assignUpVariables(false, false, false, 1);

      } else if (this.updatePromoCodeData.discountType == 2) {

        this.assignUpVariables(true, false, false, 2);

      } else if (this.updatePromoCodeData.discountType == 3) {

        this.assignUpVariables(false, false, true, 3);

      } else {

        this.assignUpVariables(false, true, false, 4);

      }
    } else {
      this.demoTrialSelectedUp = false;
      this.registeredSelectedUp = true;
      this.typeNameValUp = 2;
      if (this.updatePromoCodeData.discountType == 1) {

        this.assignUpVariables(false, false, false, 1);

      } else if (this.updatePromoCodeData.discountType == 2) {

        this.assignUpVariables(true, false, false, 2);

      } else if (this.updatePromoCodeData.discountType == 3) {

        this.assignUpVariables(false, false, true, 3);

      } else {

        this.assignUpVariables(false, true, false, 4);
      }
    }
  }

  assignUpVariables(minAmt, minAmtSec, discount, value) {
    this.minAmountSelectedUp = minAmt;
    this.minAmountSelectedSecondUp = minAmtSec;
    this.disPercentageUp = discount;
    this.demoValueSelectedUp = value;
  }


  typeChangeFunction(valueIs) {
    this.licensesNoLabel = null;
    this.licensesNoLabelValidity = null;
    this.minAmountControlLabelSec = null;
    this.discAmountControlLabel = null;
    this.minAmountControlLabel = null;
    if (valueIs == 1) {

      this.resetSelectedVariables(true,false,1,1,false);
    } else {

      this.disPercentage = true;
      this.resetSelectedVariables(false,true,2,3,false);
    }
  }

  resetSelectedVariables(trial, register, type, value, amount) {
    this.demoTrialSelected = trial;
    this.registeredSelected = register;
    this.typeNameVal = type;
    this.demoValueSelected = value;
    this.minAmountSelected = amount;
  }



  typeChangeFunctionup(valueIs) {
    this.licensesNoLabelUp = null;
    this.licensesNoLabelValidityUp = null;
    this.minAmountControlLabelSecUp = null;
    this.discAmountControlLabelUp = null;
    this.minAmountControlLabelUp = null;
    if (valueIs == 1) {

      this.resetUpVariables(true, false, 1, 1, false);
    } else {
      this.resetUpVariables(false, true, 2, 3, false);
      this.disPercentageUp = true;
    }
  }

  resetUpVariables(trial, register, type, value, amount) {
    this.demoTrialSelectedUp = trial;
    this.registeredSelectedUp = register;
    this.typeNameValUp = type;
    this.demoValueSelectedUp = value;
    this.minAmountSelectedUp = amount;
  }



  canceleditModalClick(form) {
    form.reset();
    this.editModal = false;
  }

  createModalClick() {
    this.typeNameVal = 2;
    this.typeChangeFunction(this.typeNameVal)
    this.editModal = false;
    this.createModal = true;
  }

  cancelCreateModalClick(form) {
    form.reset();
    this.productType = this.productListData[0].id;
    this.typeName = '2';
    this.typeNameVal = 2
    this.demoValueSelected = 1;
    this.demoTrialSelected = true;
    this.registeredSelected = false;
    this.createModal = false;
    this.demoTypeSelected(this.demoValueSelected);
  }

  demoTypeSelected(valueIs) {
    this.minAmountControlLabelSec = null;
    this.discAmountControlLabel = null;
    this.minAmountControlLabel = null;

    switch(valueIs) {
      case 1:
        this.resetData(false, false, false, 1);
        break;
      case 2:
        this.resetData(true, false, false, 2);
        break;
      case 3:
        this.resetData(false, false, true, 3);
        break;

      default:
          this.resetData(false, true, false, 4);
    }
  }

  resetData(minAmount,minAmountTwo,percentage,value) {
    this.minAmountSelected = minAmount;
    this.minAmountSelectedSecond = minAmountTwo;
    this.disPercentage = percentage;
    this.demoValueSelected = value;
  }

  demoTypeSelectedUp(valueIs) {

    this.minAmountControlLabelSecUp = null;
    this.discAmountControlLabelUp = null;
    this.minAmountControlLabelUp = null;

    switch (valueIs) {
      case 1:
        this.resetDataUp(false, false, false, 1);
        break;
      case 2:
        this.resetDataUp(true, false, false, 2);
        break;
      case 3:
        this.resetDataUp(false, false, true, 3);
        break;

      default:
          this.resetDataUp(false, true, false, 4);
    }

  }

  resetDataUp(minAmount,minAmountTwo,percentage,value) {
    this.minAmountSelectedUp = minAmount;
    this.minAmountSelectedSecondUp = minAmountTwo;
    this.disPercentageUp = percentage;
    this.demoValueSelectedUp = value;
  }


  cancelMoreModalClick() {
    this.moreModal = false;
    this.promoCodeData = new PaypalPromoCodeModal();
  }

  onPromoCreate(form) {
    this.showSmallLoad = true;
    this.insertPromoCode = new PaypalPromoCodeModal();
    this.insertPromoCode.productId = form.value.ProductTypeName;

    const indexpId = this.productListData.findIndex(product => product.id == this.insertPromoCode.productId);
    this.pName = '';
    this.pName = this.productListData[indexpId].productName;
    this.pAmount = 0;
    this.pAmount = this.productListData[indexpId].amount;
    this.insertPromoCode.promoCodeType = form.value.TypeName;
    this.insertPromoCode.discountType = form.value.optradio;
    this.insertPromoCode.discountPercentage = form.value.discAmountcontrolper == null ? 0 : form.value.discAmountcontrolper == undefined ? 0 : form.value.discAmountcontrolper;
    this.insertPromoCode.discountAmountUpto = form.value.discAmountcontrol == null ? 0 : form.value.discAmountcontrol == undefined ? 0 : form.value.discAmountcontrol;
    this.insertPromoCode.discountFixedAmount = form.value.minAmountcontrolsec == null ? 0 : form.value.minAmountcontrolsec == undefined ? 0 : form.value.minAmountcontrolsec;
    this.insertPromoCode.promoName = form.value.promoId;
    this.insertPromoCode.licensesCount = form.value.licensesno == null ? 0 : form.value.licensesno == undefined ? 0 : form.value.licensesno;
    this.insertPromoCode.licenseDays = form.value.licensesnovalidity == null ? 0 : form.value.licensesnovalidity == undefined ? 0 : form.value.licensesnovalidity;
    this.insertPromoCode.promoExpiry = form.value.expiry;
    this.insertPromoCode.minimumAmount = form.value.minAmountcontrol == null ? 0 : form.value.minAmountcontrol == undefined ? 0 : form.value.minAmountcontrol;
    this.insertPromoCode.promoUsage = form.value.usage;

    this.service.addNewPromoCode(this.insertPromoCode).subscribe(
    (data) => {
      if (data['Id'] !== 0) {
        const InsertedValue = {
          id: data['ReturnedId'],
          promoName: this.insertPromoCode.promoName,
          productId: this.insertPromoCode.productId,
          promoCodeType: this.insertPromoCode.promoCodeType,
          discountType: this.insertPromoCode.discountType,
          promoExpiry: this.insertPromoCode.promoExpiry,
          promoUsage: this.insertPromoCode.promoUsage,
          discountPercentage: this.insertPromoCode.discountPercentage,
          discountAmountUpto: this.insertPromoCode.discountAmountUpto,
          discountFixedAmount: this.insertPromoCode.discountFixedAmount,
          minimumAmount: this.insertPromoCode.minimumAmount,
          licensesCount: this.insertPromoCode.licensesCount,
          licenseDays: this.insertPromoCode.licenseDays,
          isUsed: true,
          promoExpiryDate: this.insertPromoCode.promoExpiry,
          reedemCount: '0',
          isExpired: false,
          paypalModal: [],
          productName: this.pName,
          updateDate: '',
          productAmount: this.pAmount
        };

        this.promoCodeList.splice(0, 0, InsertedValue);
        this.promoTotalCount = this.promoTotalCount + 1;
        AlertMessages.Show('Success', data['StatusMessage'], AlertType.Success);
      }
    }).add(() => {
      this.resetPromo(form);
    });
  }

  resetPromo(form) {
    form.reset();
    this.createModal = false;
    this.productType = this.productListData[0].id;
    this.typeName = '2';
    this.typeNameVal = 2;
    this.demoValueSelected = 1;
    this.demoTrialSelected = true;
    this.registeredSelected = false;
    this.showSmallLoad = false;
  }

  onPromoUpdate(form) {
    this.showSmallLoad = true;
    this.updatePromoCode = new PaypalPromoCodeModal();
    this.updatePromoCode.id = this.updateId;
    this.updatePromoCode.productId = form.value.ProductTypeNameupp;
    const indexpId = this.productListData.findIndex(product => product.id == this.updatePromoCode.productId);
    this.pNameUp = '';
    this.pAmountUp = 0;
    this.pNameUp = this.productListData[indexpId].productName;
    this.pAmountUp = this.productListData[indexpId].amount;
    this.updatePromoCode.productName = this.pNameUp;
    this.updatePromoCode.productAmount = this.pAmountUp;
    this.updatePromoCode.promoCodeType = form.value.TypeNameup;
    this.updatePromoCode.discountType = form.value.optradioup;

    this.updatePromoCode.discountPercentage = form.value.discAmountcontrolperup == null ? 0 : form.value.discAmountcontrolperup == undefined ? 0 : form.value.discAmountcontrolperup;
    this.updatePromoCode.discountAmountUpto = form.value.discAmountcontrolup == null ? 0 : form.value.discAmountcontrolup == undefined ? 0 : form.value.discAmountcontrolup;
    this.updatePromoCode.discountFixedAmount = form.value.minAmountcontrolsecup == null ? 0 : form.value.minAmountcontrolsecup == undefined ? 0 : form.value.minAmountcontrolsecup;
    this.updatePromoCode.promoName = form.value.promoIdup;
    this.updatePromoCode.licensesCount = form.value.licensesnoup == null ? 0 : form.value.licensesnoup == undefined ? 0 : form.value.licensesnoup;
    this.updatePromoCode.licenseDays = form.value.licensesnovalidityup == null ? 0 : form.value.licensesnovalidityup == undefined ? 0 : form.value.licensesnovalidityup;
    this.updatePromoCode.promoExpiry = form.value.expiryup;
    const updateExpiry = form.value.expiryup;

    const updatedDateSplit = updateExpiry.split('-');
    const compareDate = new Date(updatedDateSplit[0], updatedDateSplit[1] - 1, updatedDateSplit[2]);

    this.updatePromoCode.isExpired = compareDate < new Date() ? true : false;
    this.updatePromoCode.minimumAmount = form.value.minAmountcontrolup == null ? 0 : form.value.minAmountcontrolup == undefined ? 0 : form.value.minAmountcontrolup;
    this.updatePromoCode.promoUsage = form.value.usageup;
    this.service.updatePromoCode(this.updatePromoCode).subscribe(
    (data) => {
      if (data == true) {
        const indexUpdate = this.promoCodeList.findIndex(promo => promo.id == this.updatePromoCode.id);
        this.promoCodeList[indexUpdate].promoName = this.updatePromoCode.promoName;
        this.promoCodeList[indexUpdate].productId = this.updatePromoCode.productId;
        this.promoCodeList[indexUpdate].promoCodeType = this.updatePromoCode.promoCodeType;
        this.promoCodeList[indexUpdate].discountType = this.updatePromoCode.discountType;
        this.promoCodeList[indexUpdate].promoExpiry = this.updatePromoCode.promoExpiry;
        this.promoCodeList[indexUpdate].promoUsage = this.updatePromoCode.promoUsage;
        this.promoCodeList[indexUpdate].discountPercentage = this.updatePromoCode.discountPercentage;
        this.promoCodeList[indexUpdate].discountAmountUpto = this.updatePromoCode.discountAmountUpto;
        this.promoCodeList[indexUpdate].discountFixedAmount = this.updatePromoCode.discountFixedAmount;
        this.promoCodeList[indexUpdate].minimumAmount = this.updatePromoCode.minimumAmount;
        this.promoCodeList[indexUpdate].licensesCount = this.updatePromoCode.licensesCount;
        this.promoCodeList[indexUpdate].licenseDays = this.updatePromoCode.licenseDays;
        this.promoCodeList[indexUpdate].isUsed = this.isUsedUpdate;
        this.promoCodeList[indexUpdate].promoExpiryDate = this.updatePromoCode.promoExpiry;
        this.promoCodeList[indexUpdate].productName = this.updatePromoCode.productName;
        this.promoCodeList[indexUpdate].productAmount = this.updatePromoCode.productAmount;
        AlertMessages.Show('Success', 'Promo Code Updated Successfully!!!', AlertType.Success);
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Promo Code Not Updated!!!', AlertType.Error);
    }).add(() => {
      form.reset();
      this.editModal = false;
      this.showSmallLoad = false;
    });
  }

  isEnableClick(event, menuId) {
    this.showSmallLoad = true;
    if (event.target.checked == true) {
      this.isChecked = true;
      this.service.enableDisablePromoCode(menuId, this.isChecked).subscribe(
      (data: any[]) => {
        this.setClickData(menuId, true);
        AlertMessages.Show('ENABLED', 'Promo Code Is Enabled', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not Enable!', AlertType.Error);
      }).add(() => {
        this.showSmallLoad = false;
      });
    } else {
      this.isChecked = false;
      this.service.enableDisablePromoCode(menuId, this.isChecked).subscribe(
      (data: any[]) => {
        this.setClickData(menuId, false);
        AlertMessages.Show('BLOCKED', 'Promo Code is Blocked', AlertType.Error);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not block!', AlertType.Error);
      }).add(() => {
        this.showSmallLoad = false;
      });
    }
  }

  setClickData(menuId, promo) {
    const index = this.promoCodeList.findIndex(promoCode => promoCode.id == menuId);
    this.promoCodeList[index].isUsed = promo;
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode == 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  deletePromoCode(PromoId) {
    if (PromoId !== '' || PromoId !== undefined || PromoId != null) {
      const response = confirm('Are you sure you want to delete this Promocode?');
      if (response == true) {
        this.showSmallLoad = true;
        this.promoTotalCount = this.promoTotalCount - 1;
        this.service.deletePromoCode(PromoId).subscribe(
        (data) => {
          if (data == true) {
            AlertMessages.Show('Deleted', 'Promo Code Deleted', AlertType.Success);
            const deletedIndex = this.promoCodeList.findIndex(promo => promo.id == PromoId);
            this.promoCodeList.splice(deletedIndex, 1);
            // this.promoCodeList.splice(this.promoCodeList.findIndex(i => i.id == PromoId), 1);
          }
        },
        (error) => {
          AlertMessages.Show('Warning', 'PromoCode Is Already In Use', AlertType.Warning);
        }).add(() => {
          this.showSmallLoad = false;
        });
      }
    }
  }

  getPromoHistory(promoId, index) {
    let collapseStatus = document.getElementById('demo' + index).classList.contains('show');
    if (!collapseStatus) {
      this.promoActionHistory = [];
      this.historyError.display = false;
      this.service.getPromoHistory(promoId).subscribe(
      (data) => {
        this.promoActionHistory = data as PaypalPromoCodeModal[];
        const indexPaypal = this.promoCodeList.findIndex(promo => promo.id == promoId);
        this.promoCodeList[indexPaypal].paypalModal = [];
        this.promoCodeList[indexPaypal].paypalModal = this.promoActionHistory;
      },
      (error) => {
        this.historyError.error = error;
        this.historyError.display = true;
      });
    }
  }

  checkUsageUp() {

    if (this.usageLabelUp == undefined || this.usageLabelUp == null || this.usageLabelUp < 1) {
      this.usageLabelUp = this.updatePromoCodeData.promoUsage;
    }
  }

  checkValdityUp() {
    if (this.licensesNoLabelValidityUp == undefined || this.licensesNoLabelValidityUp == null || this.licensesNoLabelValidityUp < 1) {
      this.licensesNoLabelValidityUp = this.updatePromoCodeData.licenseDays;
    }

  }

  checkLicUp() {
    if (this.licensesNoLabelUp == undefined || this.licensesNoLabelUp == null || this.licensesNoLabelUp < 1) {
      this.licensesNoLabelUp = this.updatePromoCodeData.licensesCount;
    }
  }

  checkUsage() {
    if (this.usageLabel == undefined || this.usageLabel == null || this.usageLabel < 1) {
      this.usageLabel = 1;
    }
  }

  checkLicVal() {
    if (this.licensesNoLabelValidity == undefined || this.licensesNoLabelValidity == null || this.licensesNoLabelValidity < 1) {
      this.licensesNoLabelValidity = 1;
    }
  }

  checkLicensesNo() {
    if (this.licensesNoLabel == undefined || this.licensesNoLabel == null || this.licensesNoLabel < 1) {
      this.licensesNoLabel = 1;
    }
  }

  checkMinAmount() {

    if (this.minAmountControlLabel < 1) {
      this.minAmountControlLabel = null;
    } else {
      let amountProduct = 0;
      amountProduct = this.singleLicenseCost == null ? 0 : this.singleLicenseCost == undefined ? 0 : this.singleLicenseCost;
      let masterAmount = 0;
      masterAmount = this.productListData.filter(product => product.id == this.productType)[0].amount - this.singleLicenseCost;

      this.checkLicensesNo();
      const totalAmountCal = amountProduct * this.licensesNoLabel;
      const finalTotalValue = totalAmountCal + masterAmount;
      if (this.minAmountControlLabel !== undefined && this.minAmountControlLabel !== null) {
        if (this.minAmountControlLabel > finalTotalValue) {
          this.minAmountControlLabel = null;
          AlertMessages.Show('Warning', 'Minimum amount cannot be more than Product Price * No Of Licenses', AlertType.Warning);
        }
      }
    }
  }

  checkDiscountUpto() {

    if (this.discAmountControlLabel < 1) {
      this.discAmountControlLabel = null;
    }
  }

  checkFixedAmountUpto() {
    if (this.minAmountControlLabelSec < 1) {
      this.minAmountControlLabelSec = null;
    } else {
      let amountProduct = 0;
      amountProduct = this.singleLicenseCost == null ? 0 : this.singleLicenseCost == undefined ? 0 : this.singleLicenseCost;
      let masterAmount = 0;
      masterAmount = this.productListData.filter(product => product.id == this.productType)[0].amount - this.singleLicenseCost;

      this.checkLicensesNo();
      this.licensesNoLabel = 1;
      const totalAmountCal = amountProduct * this.licensesNoLabel;
      const finalTotalValue = totalAmountCal + masterAmount;
      if (this.minAmountControlLabelSec !== undefined && this.minAmountControlLabelSec !== null) {
        if (this.minAmountControlLabelSec > finalTotalValue) {
          this.minAmountControlLabelSec = null;
          AlertMessages.Show('Warning', 'Fixed Price cannot be more than Product Price * No Of Licenses', AlertType.Warning);
        }
      }
    }
  }

  changeAmount() {
    this.minAmountControlLabelSec = null;
    this.discAmountControlLabel = null;
    this.minAmountControlLabel = null;
  }

  changeAmountUp() {
    this.minAmountControlLabelSecUp = null;
    this.discAmountControlLabelUp = null;
    this.minAmountControlLabelUp = null;
  }

  checkMinAmountUp() {

    if (this.minAmountControlLabelUp < 1) {
      this.minAmountControlLabelUp = null;
    } else {
      let amountProduct = 0;
      amountProduct = this.singleLicenseCost == null ? 0 : this.singleLicenseCost == undefined ? 0 : this.singleLicenseCost;
      let masterAmount = 0;
      masterAmount = this.productListData.filter(product => product.id == this.productTypeUp)[0].amount - this.singleLicenseCost;

      this.checkLicUp();
      const totalAmountCal = amountProduct * this.licensesNoLabelUp;
      const finalTotalValue = totalAmountCal + masterAmount;
      if (this.minAmountControlLabelUp !== undefined && this.minAmountControlLabelUp !== null) {
        if (this.minAmountControlLabelUp > finalTotalValue) {
          this.minAmountControlLabelUp = this.updatePromoCodeData.minimumAmount;
          AlertMessages.Show('Warning', 'Minimum amount cannot be more than Product Price * No Of Licenses', AlertType.Warning);
        }
      }
    }

  }

  checkDiscountUptoUp() {
    if (this.discAmountControlLabelUp < 1) {
      this.discAmountControlLabelUp = null;
    }
  }

  checkFixedAmountUptoUp() {
    if (this.minAmountControlLabelSecUp) {
      this.minAmountControlLabelSecUp = null;
    }
  }

}
